import React, { useEffect, useState } from 'react';
import { Link, withRouter, Redirect } from 'react-router-dom';
import emailjs from 'emailjs-com';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import Navbar from '../Navbar';
import logo from '../../images/Limitless-BNG_WordmarkLogo.png';
import './index.scss';

const HOURS = [
  ['Monday',    '11:30AM - 2AM'],
  ['Tuesday',   '11:30AM - 2AM'],
  ['Wednesday', '11:30AM - 2AM'],
  ['Thursday',  '11:30AM - 2AM'],
  ['Friday',    '11:30AM - 2AM'],
  ['Saturday',  '11:30AM - 2AM'],
  ['Sunday',    '11:30AM - 12AM'],
];

const EMAIL_REGEX = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

const ReservationDetails = ({ history, location }) => {
  const reservation = location.state;

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!reservation) {
    return <Redirect to="/reservation" />;
  }

  const handlePhoneChange = e => {
    if (e.target.value.length <= 10 && /^\d*$/.test(e.target.value)) {
      setPhone(e.target.value);
    }
  };

  const validate = () => {
    const nextErrors = {
      firstName: firstName.length > 0 ? '' : 'Enter your name',
      lastName: lastName.length > 0 ? '' : 'Enter your last name',
      phone: /^\d{10}$/.test(phone) ? '' : 'Enter your 10 digit phone number',
      email: EMAIL_REGEX.test(email) ? '' : 'Enter a valid email address',
    };
    setErrors(nextErrors);
    return Object.values(nextErrors).every(msg => !msg);
  };

  const handleConfirm = () => {
    if (!validate() || sending) return;
    setSending(true);
    emailjs.send('default_service', 'template_hbOYPtrO', {
      name: `${firstName} ${lastName}`,
      mobile: phone,
      email,
      time: moment(reservation.time).format('LLL'),
      guests: reservation.guests.value,
      message: `Requested date: ${moment(reservation.date).format('MMMM D, YYYY')}`,
    }, process.env.REACT_APP_EMAIL_USER_ID)
      .then(() => {
        history.push('/reservation/thank-you');
      }, () => {
        setSending(false);
        setErrors(prev => ({ ...prev, submit: 'Something went wrong sending your reservation. Please try again.' }));
      });
  };

  return (
    <div className="reservation-details">
      <Navbar />

      <div className="details-body">
        <Link to="/reservation" className="back-btn">&#8592;</Link>

        <h1 className="details-title">Make a Reservation</h1>

        <div className="details-form">
          <label className="form-field">
            <span className="field-label">Name</span>
            <input value={firstName} onChange={e => setFirstName(e.target.value)} />
          </label>
          {errors.firstName && <p className="error-message">{errors.firstName}</p>}

          <label className="form-field">
            <span className="field-label">Last Name</span>
            <input value={lastName} onChange={e => setLastName(e.target.value)} />
          </label>
          {errors.lastName && <p className="error-message">{errors.lastName}</p>}

          <label className="form-field">
            <span className="field-label">Phone Number</span>
            <input value={phone} onChange={handlePhoneChange} inputMode="numeric" />
          </label>
          {errors.phone && <p className="error-message">{errors.phone}</p>}

          <label className="form-field">
            <span className="field-label">Email</span>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} />
          </label>
          {errors.email && <p className="error-message">{errors.email}</p>}

          {errors.submit && <p className="error-message">{errors.submit}</p>}

          <button className="confirm-btn" onClick={handleConfirm} disabled={sending}>
            {sending ? 'Sending...' : 'Confirm Reservation'}
          </button>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer" id="contact">
        <div className="footer-top">
          <div className="footer-col">
            <h3>Contact Us</h3>
            <p>1450 Centre St., Unit 3</p>
            <p>L4J 3N1, Thornhill, ON</p>
            <br />
            <p>T: (905) 597-5252</p>
            <p>E: limitlessbarandgrill@gmail.com</p>
          </div>
          <div className="footer-col">
            <h3>Store Hours</h3>
            {HOURS.map(([day, hrs]) => (
              <div className="hours-row" key={day}>
                <span>{day}</span>
                <span>{hrs}</span>
              </div>
            ))}
          </div>
          <div className="footer-col footer-logo-col">
            <img src={logo} alt="Limitless Bar & Grill" className="footer-logo" />
          </div>
        </div>
        <div className="footer-social">
          <a href="https://www.facebook.com/limitlessbng" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFacebookSquare} size="2x" />
          </a>
          <a href="https://www.instagram.com/limitlessbng" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faInstagram} size="2x" />
          </a>
        </div>
      </footer>
    </div>
  );
};

export default withRouter(ReservationDetails);
